export default __webpack_public_path__ + "static/media/default_image_landing.8df22154.png";